<template>
    <div>
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <staffLoginModal :settings="staffLogInModalSettings"
        style="z-index: 10;"></staffLoginModal>
    </div>
</template>

<script>
import errorMixin from '@/mixins/errorMixin';
import {mapActions, mapState} from 'vuex';
import staffLoginModal from "@/components/widgets/staffLogInModal";
import customModalDialog from '@/components/widgets/customModalDialog';

export default {
    mixins: [mixin, errorMixin],
    components: {
        customModalDialog,
        staffLoginModal,
    },
    data() {
        return {
            customModalSettings: {},
            staffLogInModalSettings: {
                show: true,
                org_uid: this.$route.params.orgGuid,
                hideOnClickOutside: false,
                onGotUserCreds: () => {
                    this.gotCreds()
                },
            },
        }
    },
    computed: {
        ...mapState({
            accessToken: state => state.auth.accessToken,
        })
    },
    async mounted() {
        if(this.accessToken) {
            this.navigateToMain()
        }
    },
    methods: {
        ...mapActions({}),
        gotCreds() {
            this.navigateToMain()
        },
        navigateToMain() {
            this.$router.push(
                {
                    name: 'SREntryPoint',
                    params: {orgGuid: this.$route.params.orgGuid,},
                    query: {
                        t: this.$route.query.t,
                        p: this.$route.query.p,
                    }
                })
        },
    }

}
</script>

<style>

</style>
<style scoped>

</style>
